import React from 'react';
import NavBar from '../../components/Navbar/NavBar';
import Footer from '../../components/Footer';
import ScrollToTop from '../../components/ScrollToTop';
import FAQ from '../../images/Pages/FAQ.jpg'
import UnserIcon from '../../images/Pages/Unser Tipp.jpg'
import { Link } from 'react-router-dom';
import pdfFile from '../../files/Checkliste.pdf'

const PagesPage = () => {
  return (
    <section>
      <ScrollToTop />
      <NavBar />
      <section className="text-gray-600 body-font">
        <div className="container px-5 py-24 mx-auto">
          <div className="flex flex-col">
            <div className="flex flex-wrap sm:flex-row flex-col py-6 mb-12">
            </div>
          </div>
          <div className="flex flex-wrap sm:-m-4 -mx-4 -mb-10 -mt-4">
            <div className="p-4 md:w-1/3 sm:mb-0 mb-6">
              <div className="rounded-lg h-64 overflow-hidden">
                <img alt="content" className="object-cover object-center h-full w-full" src={FAQ} />
              </div>
              <h2 className="text-xl font-medium title-font text-gray-900 mt-5">FAQ</h2>
              <p className="text-base leading-relaxed mt-2">Egal ob Privat  Büro  Senioren Behörden Firmenumzug. Mit uns erfahren sie einen professionellen Ablauf. Selbst bei einfachem  Transport  helfen wir ihnen gerne! </p>
              <Link to='/Pages/FAQ' className="text-indigo-500 inline-flex items-center mt-3">Erfahren Sie mehr
                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </Link>
            </div>
            <div className="p-4 md:w-1/3 sm:mb-0 mb-6">
              <div className="rounded-lg h-64 overflow-hidden">
                <img alt="content" className="object-cover object-center h-full w-full" src={UnserIcon} />
              </div>
              <h2 className="text-xl font-medium title-font text-gray-900 mt-5">Unser Tipp</h2>
              <p className="text-base leading-relaxed mt-2"> Unsere Umzugsliste als PDF zum Herunterladen</p>
              <a href={pdfFile} download='Checkliste.pdf' className="text-indigo-500 inline-flex items-center mt-3"> 
              PDF Herunterladen
                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </section>
  );
};

export default PagesPage;